import api from '.';

export default class {
    getNamesForCompany(companyId) {
        return api.requestGet(`user/names?companyCode=${companyId}`)
    }
}
